var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.firstLoad)?_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":"table","types":_vm.skeleton_types}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }